import { NotifyHelper } from "../../../helpers/toast";
import { eDmLoaiThuChiActionsObj } from "../../action-types/category/IDmLoaiThuChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiThuChiActions = {
  ...generateActions(eDmLoaiThuChiActionsObj, "LOAI_THU_CHI"),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "DELETE_MANY_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuChiActionsObj,
    "LOAI_THU_CHI",
    "DELETE_MANY_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
